import React from "react";

// Уулын нурууны давхаргууд (арынхаас урагш). Голын оргил нь x=720 орчим.
const PATHS = [
  "M0 220V112L170 58L300 94L490 24L630 76L720 8L800 70L960 22L1120 82L1290 40L1440 86V220Z",
  "M0 220V146L150 106L270 132L430 74L570 120L700 64L760 42L840 88L990 58L1130 110L1270 80L1440 116V220Z",
  "M0 220V178L130 156L250 176L400 140L540 168L660 152L740 126L820 152L970 134L1110 164L1250 142L1440 160V220Z",
];

/**
 * Оргил брэндийн уулын нурууны дүрс — hero-гийн доод ирмэг, footer-ийн дээд ирмэг.
 * layers: давхарга бүрийн fill-* класс (арынхаас урагш). 2 өгвөл урд талын 2 нурууг зурна.
 */
const MountainRidge = ({ layers = [], className = "" }) => (
  <svg
    viewBox="0 0 1440 220"
    preserveAspectRatio="none"
    aria-hidden="true"
    className={`block w-full pointer-events-none ${className}`}
  >
    {layers.map((fill, i) => (
      <path key={i} d={PATHS[PATHS.length - layers.length + i]} className={fill} />
    ))}
  </svg>
);

export default MountainRidge;
